import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../redux/hooks';
import { openAuth } from '../../redux/slice/authModalSlice';
import AuthModalManager from './AuthModalManager';
import { getAuthToken, getGuestModeFromStorage, resolvePostAuthRedirect } from '../../helper/helper';
import { useAppSelector } from '../../redux/hooks';

const LoginPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isGuestModeRedux = useAppSelector((s) => s.authModal.isGuestMode);
  const isGuestModeStorage = getGuestModeFromStorage();
  const isGuestMode = isGuestModeRedux || isGuestModeStorage;
  useEffect(() => {
    const token = getAuthToken();
    if (token) {
      // Already genuinely authenticated — honor ?redirect= if this route was reached with one
      // (e.g. a stale bookmark, or landing here mid-session) instead of discarding it and always
      // going home.
      navigate(resolvePostAuthRedirect(location.search), { replace: true });
      return;
    }
    if (isGuestMode) {
      // Guest mode is NOT authentication — if ?redirect= points at a page that itself requires a
      // real login (like this one did), sending a guest back there would just bounce them
      // straight back to /login again, forever. Guests always go home instead.
      navigate('/', { replace: true });
      return;
    }
    dispatch(openAuth('signin'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, navigate, isGuestMode]);

  const token = getAuthToken();
  if (token || isGuestMode) {
    return null;
  }

  return <AuthModalManager />;
};

export default LoginPage;
